export const integrationsDirectCdiImportSyncsImportSyncIdInferCatalogFields =
  "/integrations/direct/cdi/import-syncs/:import_sync_id/infer_catalog_fields";
